export default function TermsPage() {
  return (
    <div className="legal-page">
      <h1>Terms of Service</h1>
      <p className="legal-updated">Last Updated: February 27, 2026</p>

      <h2>Agreement</h2>
      <p>
        By accessing or using the Apollo Towing DFW dispatch system and related SMS services,
        you agree to be bound by these Terms of Service. If you do not agree, do not use our services.
      </p>

      <h2>Services</h2>
      <p>
        Apollo Towing DFW provides a towing dispatch management system for authorized users
        including administrators, dispatchers, sales representatives, and drivers. The system
        facilitates service call management, driver dispatch, and related communications.
      </p>

      <h2>User Accounts</h2>
      <ul>
        <li>Accounts are created by authorized administrators only.</li>
        <li>You are responsible for maintaining the security of your login credentials.</li>
        <li>You must not share your account or allow unauthorized access.</li>
        <li>We reserve the right to suspend or terminate accounts at any time.</li>
      </ul>

      <h2>SMS/Text Messaging Terms</h2>
      <ul>
        <li>By opting in, you consent to receive dispatch notifications from Apollo Towing DFW.</li>
        <li>Message frequency varies based on service call volume.</li>
        <li>Message and data rates may apply. Check with your carrier for details.</li>
        <li>Reply <strong>STOP</strong> to cancel text messages at any time.</li>
        <li>Reply <strong>HELP</strong> for assistance.</li>
        <li>Compatible carriers include all major US carriers. T-Mobile is not liable for delayed or undelivered messages.</li>
        <li>Text messages are used for dispatch purposes only and will not be used for marketing.</li>
      </ul>

      <h2>Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the system for any unlawful purpose.</li>
        <li>Attempt to gain unauthorized access to any part of the system.</li>
        <li>Interfere with or disrupt the operation of the system.</li>
        <li>Submit false or misleading information.</li>
      </ul>

      <h2>Disclaimer</h2>
      <p>
        The dispatch system is provided "as is" without warranties of any kind. Apollo Towing DFW
        does not guarantee uninterrupted or error-free service. We are not responsible for
        delays in SMS delivery caused by carrier networks.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        Apollo Towing DFW shall not be liable for any indirect, incidental, or consequential
        damages arising from your use of the dispatch system or SMS services.
      </p>

      <h2>Changes to Terms</h2>
      <p>
        We may update these Terms of Service at any time. Continued use of the system after
        changes constitutes acceptance of the updated terms.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have questions about these Terms, contact us at:<br />
        <strong>Apollo Towing DFW</strong><br />
        Email: info@apollotowingdfw.com
      </p>
    </div>
  );
}
